import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, Instagram, BadgeCheck } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Logo } from "./Logo";
import { NAV } from "./Header";
import { StarSil, BookSil } from "./Motifs";

export function Footer() {
  const { site } = useSite();
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-navy text-white/85 mt-24 overflow-hidden" data-testid="site-footer">
      <BookSil className="absolute -right-6 -bottom-4 w-56 text-white/5" />
      <StarSil className="absolute left-[45%] top-8 w-4 text-bej/40 motif-twinkle" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5 space-y-5">
          <Logo light />
          <p className="max-w-sm leading-relaxed">{site?.tagline}</p>
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-bej">
            <BadgeCheck className="w-4 h-4" /> M.E.B. onaylı özel kurum
          </span>
        </div>
        <div className="md:col-span-3">
          <h3 className="font-heading font-bold text-white mb-4">Sayfalar</h3>
          <ul className="space-y-2 text-sm">
            {NAV.map((n) => (
              <li key={n.to}><Link to={n.to} className="hover:text-bej transition-colors">{n.label}</Link></li>
            ))}
            <li><Link to="/kvkk" className="hover:text-bej transition-colors" data-testid="footer-kvkk-link">KVKK Aydınlatma Metni</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4 space-y-3 text-sm">
          <h3 className="font-heading font-bold text-white mb-4">İletişim</h3>
          {site?.phone && <p className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 shrink-0" /><a href={`tel:${site.phone.replace(/\s/g, "")}`} data-testid="footer-phone">{site.phone}</a></p>}
          {site?.address && <p className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 shrink-0" />{site.address}</p>}
          {site?.public_email && <p className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 shrink-0" /><a href={`mailto:${site.public_email}`}>{site.public_email}</a></p>}
          {site?.instagram && <p className="flex gap-3"><Instagram className="w-4 h-4 mt-0.5 shrink-0" /><a href={site.instagram} target="_blank" rel="noreferrer">Instagram</a></p>}
        </div>
      </div>
      <div className="relative border-t border-white/10 py-5 text-center text-xs text-white/60">
        © {year} Masal Sanat Akademi · Tüm hakları saklıdır
      </div>
    </footer>
  );
}
